import React from 'react';
import { cn } from '../../lib/utils';

/**
 * PageHeader — top-of-screen title + optional subtitle + optional actions.
 * Mirrors gotabooking's PageHeader API.
 *
 *   <PageHeader
 *     title="Dashboard"
 *     subtitle="Resumen general"
 *     actions={<Button>Crear rifa</Button>}
 *   />
 */
export default function PageHeader({ title, subtitle, actions, className }) {
  return (
    <div
      className={cn(
        'flex flex-col gap-3 border-b border-border pb-5 sm:flex-row sm:items-end sm:justify-between',
        className
      )}
    >
      <div className='min-w-0'>
        <h1 className='truncate text-2xl font-semibold tracking-tight text-foreground'>{title}</h1>
        {subtitle && <p className='mt-1 text-sm text-muted-foreground'>{subtitle}</p>}
      </div>
      {actions && <div className='flex shrink-0 items-center gap-2'>{actions}</div>}
    </div>
  );
}
